import { QueryAggregator } from "@/api/utils/QueryAggregator"
import {
  MeterpointAddress,
  addressesMatchExactly,
  addressesRepresentSameProperty,
} from "@/models/meterpointAddress/meterpointAddress"
import { MeterpointService } from "@/services/MeterpointService"

export const getMeterpointsForPostcode = (postcode: string) => {
  const queries = new QueryAggregator()

  const mpansQuery = MeterpointService.getMPANsForPostcode(postcode)
  const mprnsQuery = MeterpointService.getMPRNsForPostcode(postcode)

  queries.add(mpansQuery)
  queries.add(mprnsQuery)

  const meterpointAddresses = mpansQuery.data.map(
    (mpan) => new MeterpointAddress(mpan.address, mpan.gsp, [mpan], []),
  )

  const gsp = meterpointAddresses[0]?.gsp

  for (const mprn of mprnsQuery.data) {
    const exactMatches = meterpointAddresses.filter((m) =>
      addressesMatchExactly(m.address, mprn.address),
    )
    const matches =
      exactMatches.length > 0
        ? exactMatches
        : meterpointAddresses.filter((m) =>
            addressesRepresentSameProperty(m.address, mprn.address),
          )

    if (matches.length > 0) {
      matches.forEach((m) => m.mprns.push(mprn))
    } else {
      meterpointAddresses.push(
        new MeterpointAddress(mprn.address, gsp, [], [mprn]),
      )
    }
  }

  meterpointAddresses.sort((a, b) =>
    a.address.formatted.localeCompare(b.address.formatted, undefined, {
      numeric: true,
      sensitivity: "base",
    }),
  )

  return queries.setData(meterpointAddresses).getAggregate()
}
